/* eslint-disable */
import React from "react";
import {
    SimpleFormIterator,
    FormTab,
    useRecordContext,
    useResourceContext,
    Tab,
    ArrayField,
    FormDataConsumer,
    ReferenceInput,
    TextField,
    useDataProvider
} from "react-admin";
import { Box, Typography, Divider, Chip } from '@mui/material';

import { CourseModuleInfoShow } from '../../Common/CourseModuleInfoShow';
import { ArrayInput, AutocompleteInput, TextInput, SelectArrayInput } from "../../../lib/wrappers/Inputs";
import { VersioningTypeInput } from "../../../lib/VersioningTypeInput";

var titleStyle = { color: "#AE223F" }
var labelStyle = {
    color: '#000000',
    opacity: 0.8,
    padding: 0,
    fontsize: 1,
    fontweight: 400, lineheight: 1, letterspacing: 0.00938
}
export const ModulesInputs = (props) => {
    const resource = useResourceContext();
    const record = useRecordContext();

    return <FormTab label="Modules" {...props}>
        <Box flex={4} sx={{ paddingBottom: '20px' }}>
            <Typography variant="h6" style={titleStyle}>
                Course | <small><TextField source="id" label={false} /></small> | <small><TextField source="courseCode" label={false} /></small>
            </Typography>
        </Box> 
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '5px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Modules" /></b></Divider>
            </Box>
        </Box>
        <ArrayInput source="moduleInfos" label={false} fullWidth>
            <SimpleFormIterator disableReordering fullWidth>
                <FormDataConsumer>
                    {({ getSource, formData }) => {
                        let moduleIds = formData && formData.moduleInfos
                        ? formData.moduleInfos.map((module) => module.moduleId)
                        : null;
                        
                        let filter = moduleIds ? { ids_neq: moduleIds.filter(id => id !== '') } : undefined;

                        return <>
                        <Box display="flex" width={1}>
                            <Box flex={4}>
                                <ReferenceInput reference="Module" source={getSource("moduleId")} label='myroot.module' filter={filter}> 
                                    <AutocompleteInput optionText={ModuleTitleRenderer} fullWidth />
                                </ReferenceInput>
                            </Box>
                            <Box flex={1} ml="0.5em">
                                <AutocompleteInput source={getSource("type")} choices={[
                                    { id: 'optional', name: 'myroot.optional' },
                                    { id: 'core', name: 'myroot.core' },
                                    { id: 'specified', name: 'myroot.specified' }
                                ]} label="Type" fullWidth />
                            </Box>
                            <Box flex={4} ml="0.5em">
                                {formData.learningOutcomes ?
                                    <SelectArrayInput source={getSource("learnningOutcomes")} label="Assign Learning Outcome" optionValue="id" optionText={optionRenderer} choices={LearningOutcomeChoices(formData.learningOutcomes, formData.professionalLearningOutcomes, formData.intellectualLearningOutcomes)} fullWidth />
                                    : null}
                            </Box>
                        </Box>
                        </>
                    }
                    }
                </FormDataConsumer>
            </SimpleFormIterator>
        </ArrayInput>
        <VersioningTypeInput source="versioningType" resource={resource} />
    </FormTab>
}
const optionRenderer = choice => `${choice.id} - ${choice.Title?.substring(0, 75)}`;

export const ModuleShow = (props) => {

    return <Tab label="Modules" {...props}>
        <ArrayField source="moduleInfos">
            <CourseModuleInfoShow />
        </ArrayField>
    </Tab>


}

export const ModuleTitleRenderer = choice => `${choice.moduleCode} - ${choice.shortTitle}`;


const LearningOutcomeChoices = (learningOutcomeArray, professionalLearningOutcomeArray, intellectualLearningOutcomeArray) => {

    var choices = [];
    if (Array.isArray(learningOutcomeArray) && learningOutcomeArray.length) {
        learningOutcomeArray?.forEach(learningOutcome => {
            if (typeof learningOutcome !== 'undefined' && learningOutcome) {
                var choice = { Title: learningOutcome.Title, description: learningOutcome.description, id: learningOutcome.id }
                choices.push(choice);
            }
        });
    }
    if (Array.isArray(professionalLearningOutcomeArray) && professionalLearningOutcomeArray.length) {
        professionalLearningOutcomeArray?.forEach(learningOutcome => {
            if (typeof learningOutcome !== 'undefined' && learningOutcome) {
                var choice = { Title: learningOutcome.Title, description: learningOutcome.description, id: learningOutcome.id }
                choices.push(choice);
            }
        });
    }
    if (Array.isArray(intellectualLearningOutcomeArray) && intellectualLearningOutcomeArray.length) {
        intellectualLearningOutcomeArray?.forEach(learningOutcome => {
            if (typeof learningOutcome !== 'undefined' && learningOutcome) {
                var choice = { Title: learningOutcome.Title, description: learningOutcome.description, id: learningOutcome.id }
                choices.push(choice);
            }
        });
    }
    if (choices.length > 0) {
        return choices;
    }
    return [{ id: "No data yet", name: "No data yet" }];
}


function getByValue(arr, value) {
    for (var i = 0, iLen = arr.length; i < iLen; i++) {
        if (arr[i].id == value) {
            return arr[i];
        }
    }
}